import { RelationshipType } from "@libs/gateways/practice/PracticeGateway.dtos.ts";

export const otherRelationships = [RelationshipType.General];
